<div class="custom-backdrop" *ngIf="show"></div>
<div [ngClass]="{'pop-up-wrapper' : true, 'uibg': data.type === 'unIdentifiedUser'}" *ngIf="show" >
  <div class="title">
    <span *ngIf="data && data.type === 'featureToCome'" >{{'POPUP.IN_PROGRESS.HEADER' | translate}}</span>
    <span class="five" *ngIf="data && data.type === 'five'">{{'POPUP.PER_WEEK.HEADER' | translate}}</span>
    <span class="five" *ngIf="data && data.type === 'excludedFromPaywall'">{{'POPUP.EXCLUDED_FROM_PAYWALL.HEADER' | translate}}</span>
    <span class="five" *ngIf="data && data.type === 'confirmEdit'">{{'POPUP.CONFIRM.HEADER' | translate}}</span>
    <span class="five" *ngIf="data && data.type === 'menuPlatformLinks'">{{'POPUP.PLATFORM_REDIRECT.HEADER' | translate}}</span>
    <span class="five" *ngIf="data && data.type === 'noAccess'">{{'ERROR.PROFILE_SELECTOR.NO_ACCESS_HEAD' | translate}}</span>
    <span class="uipopup-head" *ngIf="data && data.type === 'unIdentifiedUser'">{{'POPUP.UNIDENTIFIED_USER.HEADER' | translate}}</span>
    <span *ngIf="data && data.type === 'newFeature'">NOUVEAU</span>
    <span class="devoir" *ngIf="data && data.type === 'devoir'">1 semaine gratuite</span>
    <img class="close" (click)="closeTooltip()" *ngIf="data && data.type !== 'unIdentifiedUser'" src="../../../assets/img/close-feature-tooltip.png"/>
  </div>
  <div class="content" *ngIf="data && data.type === 'featureToCome'"> {{ 'POPUP.IN_PROGRESS.TEXT' | translate }}</div>
  <div class="content" *ngIf="data && data.type === 'noAccess'">{{ 'ERROR.PROFILE_SELECTOR.NO_ACCESS' | translate:{profileName: data.profileName } }} </div>
  <div class="content" *ngIf="data && data.type === 'five' && (data.article_type === 'mquo' || data.article_type === 'actu' || data.article_type === 'lepq')">
    {{'POPUP.PER_WEEK.TEXT.AGGREGATOR.NORMAL' | translate: {days: data.data} }}
  </div>
  <div class="content" *ngIf="data && data.type === 'excludedFromPaywall'">
    {{'POPUP.EXCLUDED_FROM_PAYWALL.TEXT.AGGREGATOR.NORMAL' | translate: {newspaper: data.data} }}
  </div>
  <div class="content" *ngIf="data && data.type === 'five' && (data.article_type === 'actuvideo' || data.article_type === 'mquovideo') && (data.platform === 'mquovideo' || data.platform === 'actuvideo')">
    {{'POPUP.PER_WEEK.TEXT.PLATFORM.VIDEO' | translate: {days: data.data} }}
  </div>
  <div class="content" *ngIf="data && data.type === 'five' && (data.article_type === 'actuvideo' || data.article_type === 'mquovideo') && (data.platform === 'mquovideo' || data.platform === 'actuvideo')">
    {{'POPUP.EXCLUDED_FROM_PAYWALL.TEXT.PLATFORM.VIDEO' | translate: {newspaper: data.data} }}
  </div>
  <div class="content" *ngIf="data && data.type === 'five' && (data.article_type === 'actuvideo' || data.article_type === 'mquovideo') && data.platform === 'playbacpresse'">
    {{'POPUP.PER_WEEK.TEXT.AGGREGATOR.VIDEO' | translate: {days: data.data} }}
  </div>
  <div
    class="content"
    *ngIf="data && data.type === 'five' && (data.article_type === 'week' || data.article_type === 'sema' || data.article_type === 'mlwk' || data.article_type === 'woch') && (data.platform === 'mlwk' || data.platform === 'week' || data.platform === 'sema' || data.platform === 'woch')">
    {{'POPUP.PER_WEEK.TEXT.PLATFORM.WEEKLY_SUPPLEMENTS' | translate: {days: data.data} }}
  </div>
  <div
    class="content"
    *ngIf="data && data.type === 'five' && (data.article_type === 'week' || data.article_type === 'sema' || data.article_type === 'mlwk' || data.article_type === 'woch') && (data.platform === 'playbacpresse')">
    {{'POPUP.PER_WEEK.TEXT.AGGREGATOR.WEEKLY' | translate: {days: data.data} }}
  </div>
  <div class="content" *ngIf="data && data.type === 'newFeature'">Partagez et sauvegardez vos articles préférés!</div>
  <img *ngIf="data && data.type === 'newFeature'" class="ok" src="../../../assets/img/share&fav_buttons_mobile.png"/>
  <div class="content" *ngIf="data && data.type === 'hybridApp'">
    Afin de bénéficier d'une navigation optimisée, vous pouvez télécharger
    l'application pour votre appareil en cliquant sur le lien suivant.
  </div>
  <div class="content" *ngIf="data && data.type === 'confirmEdit'">
    Vous êtes sur le point de modifier les informations relatives à votre
    abonnement, si les nouvelles informations sont erronées vous ne pourrez plus
    accéder à vos contenus en ligne.
  </div>
  <div class="content" *ngIf="data && data.type === 'menuPlatformLinks'">{{ 'POPUP.PLATFORM_REDIRECT.TEXT' | translate }}</div>
  <div class="content devoir" *ngIf="data && data.type === 'devoir'">
    <div>
      Pour profiter gratuitement pendant 7 jours des journaux PDF:
    </div>
    <ul>
      <li class="li-pop-up">1. Créez un compte</li>
      <li>2. Créez le profil de votre enfant (ne pas remplir le champ numéro d’abonné)
      </li>
      <li>3. Indiquez le code promo dans le profil de votre enfant:</li>
    </ul>
    <div class="row">
      <div class="col1">Le Petit Quotidien (6-10 ans):</div>
      <div class="col2">SDLPLPQ</div>
    </div>
    <div class="row">
      <div class="col1">Mon Quotidien (10-13 ans):</div>
      <div class="col2">SDLPMQ</div>
    </div>
    <div class="row">
      <div class="col1">L’ACTU (13-18 ans):</div>
      <div class="col2">SDLPACTU</div>
    </div>
    <div class="row last">
      <div class="col1">L’ÉCO (15-20 ans):</div>
      <div class="col2">SDLPECO</div>
    </div>
    <ul>
      <li class="li-pop-up">4. Retrouvez vos journaux dans le menu "Le journal PDF". Bonne lecture!</li>
    </ul>
  </div>
  <div *ngIf="data && (data.type === 'featureToCome' || data.type === 'newFeature')" class="content-button">
    <ion-button (click)="closeTooltip()" class="createuser">{{'POPUP.PER_WEEK.BUTTON' | translate}}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'excludedFromPaywall'" class="content-button d-flex">
    <ion-button (click)="goToOffers()" class="createuser">{{'POPUP.EXCLUDED_FROM_PAYWALL.BUTTON' | translate}}</ion-button>
    <ion-button (click)="closeAndRedirect('login')" class="createuser">{{'POPUP.EXCLUDED_FROM_PAYWALL.BUTTON_CONNECT' | translate}}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'five'" class="content-button">
    <ion-button (click)="goToOffers()" class="createuser">{{'HEADER.S_ABONNER' | translate}}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'hybridApp'" class="content-button">
    <ion-button (click)="openStore()" class="createuser">Télécharger L'application</ion-button>
  </div>
  <div *ngIf="data && data.type === 'confirmEdit'" class="content-button">
    <ion-button (click)="closeAndConfirm()" class="createuser">{{ 'POPUP.CONFIRM.BUTTON' | translate }}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'confirmEdit'" class="content-button">
    <ion-button (click)="closeTooltip()" class="createuser cancel">Annuler</ion-button>
  </div>
  <div *ngIf="data && data.type === 'menuPlatformLinks'" class="content-button">
    <ion-button (click)="closeAndConfirm()" class="createuser">{{ 'POPUP.PLATFORM_REDIRECT.BUTTON' | translate }}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'menuPlatformLinks'" class="content-button">
    <ion-button (click)="closeTooltip()" class="createuser cancel">{{ 'POPUP.PLATFORM_REDIRECT.BUTTON_2' | translate }}</ion-button>
  </div>
  <div *ngIf="data && data.type === 'noAccess'" class="content-button">
    <ion-button (click)="closeAndConfirm()" class="createuser cancel">{{ 'POPUP.INVALID_ACCESS.BUTTON' | translate }}</ion-button>
  </div>
  <!-- Unidentified user pop-up start -->
  <div class="content uipopup-text" *ngIf="data && data.type === 'unIdentifiedUser'">Je suis abonné(e)</div>
  <div *ngIf="data && data.type === 'unIdentifiedUser'" class="content-button">
    <ion-button (click)="closeAndRedirect('login')" class="createuser cancel unidentified-popup-buttton small">JE ME CONNECTE</ion-button>
  </div>
  <div *ngIf="data && data.type === 'unIdentifiedUser'" class="content-button">
    <ion-button (click)="closeAndRedirect('create')" class="createuser cancel unidentified-popup-buttton small">CRÉER MON COMPTE</ion-button>
  </div>
  <div class="uipop" *ngIf="data && data.type === 'unIdentifiedUser'"><hr class="hr-abs" /></div>
  <div class="content uipopup-text" *ngIf="data && data.type === 'unIdentifiedUser'">Je ne suis pas abonné(e)</div>
  <div class="content uipopup-largetext" *ngIf="data && data.type === 'unIdentifiedUser'">{{ 'POPUP.UNIDENTIFIED_USER.TEXT' | translate }}</div>
  <div *ngIf="data && data.type === 'unIdentifiedUser'" class="content-button">
    <ion-button (click)="closeAndRedirect('create')" class="unidentified-popup-buttton big inverted">J'AI UN CODE</ion-button>
  </div>
  <div *ngIf="data && data.type === 'unIdentifiedUser'" class="content-button ui-bottom-margin">
    <ion-button (click)="closeAndStamp()" class="unidentified-popup-buttton big inverted">{{ 'POPUP.UNIDENTIFIED_USER.BUTTON' | translate }}</ion-button>
  </div>
  <div class="content uipopup-largetext" *ngIf="data && data.type === 'unIdentifiedUser'">
    Si vous souhaitez vous abonner, <a href="https://playbacpresse.fr" target="_blank">cliquez ici</a>
  </div>
  <!-- Unidentified user pop-up stop -->
</div>
